<template>
  <form
    :class="cx('root')"
    v-bind="ptmi('root')"
    @submit.prevent="onSubmit"
  >
    <slot
      :register="register"
      :valid="valid"
      :reset="reset"
      v-bind="states"
    />
  </form>
</template>

<script>
import { omit } from '@primeuix/utils'
import { useForm } from '@primevue/forms/useform'
import BaseComponent from '@primevue/core/basecomponent'
import FormStyle from '@primevue/forms/form/style'
import { getCurrentInstance } from 'vue'

export default {
  name: 'PrimeVueFormCompat',
  extends: BaseComponent,
  style: FormStyle,
  inheritAttrs: false,
  props: {
    resolver: {
      type: Function,
      default: null,
    },
    initialValues: {
      type: Object,
      default: null,
    },
    validateOnValueUpdate: {
      type: [Boolean, Array],
      default: true,
    },
    validateOnBlur: {
      type: [Boolean, Array],
      default: false,
    },
    validateOnMount: {
      type: [Boolean, Array],
      default: false,
    },
    validateOnSubmit: {
      type: [Boolean, Array],
      default: true,
    },
  },
  emits: ['submit'],
  provide() {
    return {
      $pcForm: this,
      $parentInstance: this,
    }
  },
  setup(props, { emit, expose }) {
    const $form = useForm(props)

    const register = (field, options) => {
      const [, fieldProps] = $form.defineField(field, options)
      return fieldProps
    }

    const getFieldState = (fieldName) => $form.states?.[fieldName]
    const getFieldValue = (fieldName) => getFieldState(fieldName)?.value

    const onSubmit = $form.handleSubmit((event) => {
      emit('submit', event)
    })

    const api = {
      register,
      onSubmit,
      getFieldState,
      getFieldValue,
      ...omit($form, ['handleSubmit']),
    }

    const instance = getCurrentInstance()
    if (instance?.proxy) {
      Object.assign(instance.proxy, {
        register,
        onSubmit,
        getFieldState,
        getFieldValue,
      })
    }

    expose(api)

    return api
  },
}
</script>

